export function searchNodeByClass(vnode: any, className: string) : any
{
  if (!vnode) return;

  if (vnode.attrs && vnode.attrs.className
    && vnode.attrs.className.indexOf(className) > -1) {
    return vnode;
  }

  // Проверяем дочерние элементы, если они существуют
  if (vnode.children) {
    for (let child of vnode.children) {
      const result = searchNodeByClass(child, className);
      if (result) {
        return result; // Возвращаем найденный элемент
      }
    }
  }

  return null; // Если ничего не найдено, возвращаем null
}

export default {
  'searchNodeByClass': searchNodeByClass,
};
